<template>
  <div class="footer">
    <div class="inner_wrap">
      <img :src="logo" alt="">
      <p>Copyright 2018 Longtugame All Right Reserved</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-footer',
  data () {
    return {

    }
  },
  computed: {
    logo() {
      return this.$i18n.locale === 'th' ? require('@/assets/images/logo_bai.png') : require('@/assets/images/logo_bai.png')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/scss/variable.scss";
  .footer{
    width: 100%;
    height: 100px;
    background: $footer-background;
    color: #fff;
    text-align: center;
    padding: 10px 20px;
    box-sizing: border-box;
    .inner_wrap{
      display: inline-block;
      overflow: hidden;
      >img{
        display: inline-block;
        vertical-align: middle;
        float:left;
        height: 40px;
        margin-top: 22px;
      }
      p{
        float: left;
        vertical-align: middle;
        line-height: 80px;
        margin-left: 20px;
        font-size: 18px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue